module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "elisa"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Firstly, I’d like to thank my friend Madeleine for helping me come up with the idea to write this book, she really did help drive me to want to write it. Not to mention the fact that she helped me with Arriana greatly, whose personality matches Madeleine’s to a fault. Next, I’d like to thank my friend Vyvus for giving me the surname, Von Karma, it’s just what adds that little formal twist to Nova. I would also like to thank Ines Stuchfield for giving me the initial idea for the cover.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 69
// module chunks = 0